import { useEffect } from 'react';
import { Link,useNavigate,useLocation } from 'react-router-dom';
import "./OrderSummary.css"; 
import { useOrder } from '../../../../hooks/OrderContext';

export const OrderSummary = () => {
    const { completeOrder } = useOrder();
    const location = useLocation();
    const navigate= useNavigate();
    const {transactionId}= location.state || '';
    useEffect(()=>{
        sessionStorage.removeItem("wa_crt_cid");
    },[])
    useEffect(() => {
        // Mark the order as completed
        completeOrder();
        // Prevent going back to the previous page and redirect to cart if attempted
        window.history.pushState(null, "", window.location.href);
        const onPopState = () => {
            navigate('/', { replace: true }); // Redirect to cart on "back" action
        };
        window.addEventListener('popstate', onPopState);
        // Cleanup when the component is unmounted
        return () => {
            window.removeEventListener('popstate', onPopState);
        };
    }, [completeOrder, navigate]);
    return (
        <div className='summary-details my-5'>
            <div className="orderSummary d-flex align-items-center">
                <h2>Thank You for Your Order!</h2>
                <p>Your order has been successfully placed.</p>
                <p>You will recieve a confirmation details including pass,invoice on your email</p>
                {
                    transactionId && <><p>Order Transaction Id is {transactionId}</p></>
                }
                <p>We hope you enjoy your pass, and thank you for choosing us!</p>
                <Link to="/" className="back-to-home">Back to Home</Link>
            </div>
        </div>
    );
};